export default "__VITE_ASSET__DSAhY6_D__"